module.exports = __webpack_public_path__ + "img/山海经-小图.c961a3d9.png";